import { render, staticRenderFns } from "./styleFive.vue?vue&type=template&id=22f250ca&scoped=true&"
import script from "./styleFive.vue?vue&type=script&lang=js&"
export * from "./styleFive.vue?vue&type=script&lang=js&"
import style0 from "./styleFive.vue?vue&type=style&index=0&id=22f250ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f250ca",
  null
  
)

export default component.exports